import { imageNames } from "@/src/constants/imageConstants.js";
import DashboardService from "@/src/api/DashboardService.js";

export const companyTabs = [
  { title: "Activity" },
  { title: "Employees" },
  { title: "Notes" },
  { title: "Emails" },
  { title: "Calls" },
  { title: "Tasks" },
  { title: "Meetings" },
  { title: "Livechat" },
  { title: "Market Research" },
];

export const prospectCompanyTabs = [
  { title: "Activity" },
  { title: "Employees" },
];

export const companySizeOptions = [
  "1-10",
  "11-50",
  "51-100",
  "101-500",
  "501-1000",
  "1001-5000",
  "5001-10,000",
  "10,000+",
];

export const companiesEmptyScreen = {
  title: "Find your ideal companies",
  description:
    "Enter details about your ideal company. SuperAGI will find prospects that suit your criteria.",
  src: imageNames.COMPANIES_GREY,
  alt: "companies_empty_screen",
};

export const findCompaniesHeaders = [
  {
    label: "Name",
    key: "name",
    width: 3,
    view: "logo",
    url: [
      { key: "linkedin_url", image: imageNames.PROSPECTING_LINKEDIN_GREY },
      { key: "website", image: imageNames.PROSPECTING_BROWSER_GREY },
    ],
  },
  { label: "Industry", key: "industry", width: 3 },
  { label: "Location", key: "location", width: 3 },
];

export const customerTableHeaders = [
  {
    label: "Company Name",
    key: "name",
    width: 3,
    avatar: "logo_url",
    suffix: true,
  },
  { label: "Company Score", key: "score", width: 2 },
  { label: "Company Owner", key: "owner", width: 3, view: true },
  { label: "Industry", key: "industry", width: 2 },
  { label: "Country/Region", key: "country", width: 2 },
  { label: "Tags", key: "tags", width: 2 },
];

// Default lifecycle stage options (fallback)
export const defaultLifecycleStageOptions = [
  { value: "Lead", label: "Lead" },
  { value: "Customer", label: "Customer" },
];

// Function to fetch lifecycle stage options from backend
export const fetchLifecycleStageOptions = async () => {
  try {
    const response = await DashboardService.fetchObjectPropertyStatus(
      "company",
      "lifecycle_stage",
    );
    if (response.success && response.property_details?.options) {
      // Return options as-is, no hardcoded mapping - let the backend handle everything
      return response.property_details.options.map((option) => ({
        value: option, // Use the original value for filtering
        label: option, // Use the original value for display
      }));
    }
    return defaultLifecycleStageOptions;
  } catch (error) {
    console.error("Error fetching lifecycle stage options:", error);
    return defaultLifecycleStageOptions;
  }
};

// Legacy export for backward compatibility
export const lifecycleStageOptions = defaultLifecycleStageOptions;
